import ClipboardJS from 'clipboard/dist/clipboard.min';
import $ from "../jquery_global";

window.Restaurant = {
  init() {
    let self = this
    var clipboard =new ClipboardJS('.clipboard-btn');
    clipboard.on('success', function(e) {
      self.setTooltip(e.trigger, 'Copied!');
      self.hideTooltip(e.trigger);
    });
    self.handleBannerImage();
    self.handleCommonTraceImage();
  },

  setTooltip(btn, message) {
    $(btn).tooltip('hide')
      .attr('data-original-title', message)
      .tooltip('show');
  },

  hideTooltip(btn) {
    setTimeout(function() {
      $(btn).tooltip( "dispose" )
    }, 1000);
  },

  handleBannerImage() {
    $(document).off('click', '.delete-banner-image-btn').on('click', '.delete-banner-image-btn', (event) => {
      const $img = $(event.currentTarget).siblings('img')

      $.ajax({
        url: `/admin/restaurants/${$img.data('restaurantId')}/banner_image`,
        type: 'DELETE',
        data: {
          banner_image_id: $img.data('attachmentId')
        },
        dataType: "json",
        success: (data) => {
          $img.parents('.col-auto').remove()
        },
        failure: (error) => {
          alert(error)
        }
      })
    })

    $(document).off('click', 'button.upload-banner-image-btn').on('click', 'button.upload-banner-image-btn', function(e) {
      e.preventDefault();
      const btn = $(e.currentTarget)
      btn.attr('disabled','disabled')
      if (document.querySelector('#bannerImageUpload').files.length < 1) {
        alert('Select atleast 1 image to upload')
        return;
      }

      const data = new FormData()
      for (const file of document.querySelector('#bannerImageUpload').files) {
        data.append('banner_images[]', file)
      }
      $.post({
        url: btn.data('url'),
        type: 'POST',
        data,
        dataType: 'script',
        processData: false,
        contentType: false,
      }).done((_res) => {
        $('.banner-image-file-label').html('Select images');
      }).fail(function() {
        btn.removeAttr('disabled')
      })
    })
  },

  handleCommonTraceImage() {
    $(document).off('click', '.delete-common-image-btn').on('click', '.delete-common-image-btn', (event) => {
      const $img = $(event.currentTarget).siblings('img')

      $.ajax({
        url: `/admin/restaurants/${$img.data('restaurantId')}/common_trace_image`,
        type: 'DELETE',
        data: {
          common_trace_image_id: $img.data('attachmentId')
        },
        dataType: "json",
        success: (data) => {
          $img.parents('.col-auto').remove()
        },
        failure: (error) => {
          alert(error)
        }
      })
    })

    $(document).off('click', 'button.upload-common-trace-image-btn').on('click', 'button.upload-common-trace-image-btn', function(e) {
      e.preventDefault();
      const btn = $(e.currentTarget)
      btn.attr('disabled','disabled')
      if (document.querySelector('#commonTraceImageUpload').files.length < 1) {
        alert('Select atleast 1 image to upload')
        return;
      }

      const data = new FormData()
      for (const file of document.querySelector('#commonTraceImageUpload').files) {
        data.append('common_trace_images[]', file)
      }
      $.post({
        url: btn.data('url'),
        type: 'POST',
        data,
        dataType: 'script',
        processData: false,
        contentType: false,
      }).done((_res) => {
        $('.common-trace-image-file-label').html('Select images');
      }).fail(function() {
        btn.removeAttr('disabled')
      })
    })
  }
}
